<div
  class="min-h-dvh bg-[linear-gradient(135deg,#f8f8ff_0%,#f3f7ff_52%,#ffffff_100%)] text-content-light dark:bg-[linear-gradient(180deg,#0f172a_0%,#111c34_100%)] dark:text-content-dark"
  [class.dark]="theme.isDark()"
  [style.--brand-color]="theme.primaryColor().hex"
  [style.--brand-light]="theme.primaryColor().light"
  [style.--brand-dark]="theme.primaryColor().dark"
  [style.--brand-rgb]="theme.primaryColor().rgb"
>
  <div class="grid min-h-dvh xl:grid-cols-[1.9fr_minmax(420px,0.95fr)]">
    <section
      class="relative hidden overflow-hidden border-r border-white/60 bg-white/40 xl:flex xl:flex-col dark:border-line-dark/70 dark:bg-slate-950/20"
      [style.background]="theme.isDark() ? null : 'var(--brand-gradient)'"
    >
      <div class="absolute inset-0 bg-[radial-gradient(circle_at_18%_28%,rgba(var(--brand-rgb,115_103_240)/0.08),transparent_20%),radial-gradient(circle_at_78%_36%,rgba(59,130,246,0.08),transparent_18%),radial-gradient(circle_at_62%_74%,rgba(45,212,191,0.08),transparent_20%)] dark:bg-[radial-gradient(circle_at_18%_28%,rgba(var(--brand-rgb,115_103_240)/0.18),transparent_20%),radial-gradient(circle_at_78%_36%,rgba(56,189,248,0.1),transparent_18%),radial-gradient(circle_at_62%_74%,rgba(45,212,191,0.12),transparent_20%),linear-gradient(180deg,rgba(15,23,42,0.6),rgba(17,28,52,0.25))]"></div>
      <div class="relative flex items-center justify-between px-10 pt-8">
        <a class="text-[1.25rem] font-extrabold tracking-[-0.03em] text-brand" routerLink="/authentication/login">underwriter-platform</a>
      </div>

      <div class="relative flex flex-1 items-center justify-center px-12 pb-16 pt-10">
        <div class="absolute left-16 top-24 h-24 w-24 rounded-full bg-brand/8 blur-2xl"></div>
        <div class="absolute right-20 top-32 h-20 w-20 rounded-full bg-sky-300/20 blur-2xl"></div>
        <div class="absolute bottom-20 right-24 h-32 w-32 rounded-full bg-emerald-200/25 blur-3xl"></div>
        <img
          alt="Forgot password illustration"
          class="relative z-10 max-h-[72vh] w-full max-w-4xl object-contain drop-shadow-[0_28px_44px_rgba(47,43,61,0.08)]"
          [src]="theme.isDark() ? '/pages/reset-password-v2-dark.svg' : '/pages/forgot-password-v2.svg'"
        />
      </div>
    </section>

    <section class="relative flex items-center justify-center bg-white/55 px-5 py-10 dark:bg-slate-950/10 sm:px-8 lg:px-12">
      <div class="w-full max-w-[32rem]">
        <div class="mb-8 xl:hidden">
          <a class="text-[1.25rem] font-extrabold tracking-[-0.03em] text-brand" routerLink="/authentication/login">underwriter-platform</a>
        </div>

        <div class="rounded-[1rem] border border-white/80 bg-white/92 p-7 shadow-[0_28px_60px_rgba(31,42,90,0.12)] backdrop-blur dark:border-line-dark dark:bg-[linear-gradient(180deg,rgba(17,28,52,0.96)_0%,rgba(15,23,42,0.98)_100%)] dark:shadow-[0_28px_60px_rgba(2,6,23,0.45)] sm:p-10">
          <div class="space-y-2">
            <h3 class="text-[1.25rem] font-semibold tracking-[-0.03em] text-[#3d4670] dark:text-white">Forgot Password?</h3>
            <p class="text-[1rem] text-[#7c84a6] dark:text-muted-dark">
              Enter your email and we'll send you instructions to reset your password.
            </p>
          </div>

          <form class="mt-8 space-y-5" [formGroup]="form" (ngSubmit)="submit()">
            <label class="block">
              <span class="mb-2 block text-sm font-medium text-[#67708f] dark:text-muted-dark">Email</span>
              <input
                class="h-12 w-full rounded-xl border border-[#d8ddf0] bg-white px-4 text-[0.95rem] text-[#47506e] outline-none transition placeholder:text-[#a3aac4] focus:border-brand focus:ring-4 focus:ring-brand/10 dark:border-line-dark dark:bg-slate-950/20 dark:text-content-dark dark:placeholder:text-muted-dark"
                formControlName="email"
                placeholder="john@example.com"
                type="email"
              />
            </label>

            @if (form.controls.email.invalid && form.controls.email.touched) {
              <p class="text-sm text-status-danger">Enter a valid email address.</p>
            }

            @if (submitted()) {
              <div class="rounded-2xl border border-status-success/20 bg-status-success/10 px-4 py-3 text-sm text-status-success">
                Reset instructions were prepared for <strong>{{ form.controls.email.value }}</strong>.
              </div>
            }

            <button
              class="inline-flex h-12 w-full items-center justify-center rounded-xl bg-[linear-gradient(135deg,var(--brand-color,#7367f0)_0%,var(--brand-dark,#5f52db)_100%)] text-[1rem] font-semibold text-white shadow-[0_18px_40px_rgba(var(--brand-rgb),0.28)] transition hover:translate-y-[-1px] hover:shadow-[0_22px_42px_rgba(var(--brand-rgb),0.34)]"
              type="submit"
            >
              Send reset link
            </button>
          </form>

          <div class="mt-7 text-center">
            <a class="inline-flex items-center gap-2 text-[0.96rem] font-medium text-brand transition hover:text-brand-dark" routerLink="/authentication/login">
              <i class="fa-solid fa-angle-left text-xs"></i>
              <span>Back to login</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
